module.exports={render:function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "ui segment"
  }, [_vm._h('h3', {
    staticClass: "ui header"
  }, ["Edit Profile"]), " ", _vm._h('ProfileForm', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile),
      expression: "profile"
    }],
    domProps: {
      "value": (_vm.profile)
    },
    on: {
      "save": _vm.saveProfile,
      "cancle": _vm.back,
      "input": function($event) {
        _vm.profile = $event
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3c6179e6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProfileEdit.vue
// module id = 241
// module chunks = 2